import { render, staticRenderFns } from "./AnswersList.vue?vue&type=template&id=339182d0&scoped=true&lang=pug&"
import script from "./AnswersList.vue?vue&type=script&lang=js&"
export * from "./AnswersList.vue?vue&type=script&lang=js&"
import style0 from "./AnswersList.vue?vue&type=style&index=0&id=339182d0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339182d0",
  null
  
)

component.options.__file = "AnswersList.vue"
export default component.exports